/**
 * Русское склонение по числу - ОДИН формат на весь продукт.
 *
 * Находка владельца: «поставил лайков: 1» в ленте эфира. Форматтер
 * существовал - но жил рядом с привязками и применялся к монетам, а
 * остальные места писали число через двоеточие. Двоеточие вместо склонения -
 * это не сокращение, а признак интерфейса, переведённого наспех: по-русски
 * число и существительное согласуются.
 *
 * Поэтому формат переехал сюда, в общее место, и применяется везде, где
 * число стоит рядом с существительным: лента, гифтеры, счётчики, карточки
 * подарков, пределы каталога, аналитика, история.
 *
 * Ворота: `e2e/console-plural.spec.ts` обходит поверхности продукта и ищет
 * строки вида «<слово>: <число>» - их быть не должно.
 */
export function plural(n: number, forms: [string, string, string]): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  const form =
    mod10 === 1 && mod100 !== 11
      ? forms[0]
      : mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)
        ? forms[1]
        : forms[2];

  return `${n} ${form}`;
}

/** Готовые слова, которые встречаются больше чем в одном месте. */
export const coins = (n: number): string => plural(n, ['монета', 'монеты', 'монет']);

/**
 * ТО ЖЕ ЧИСЛО, НО В ВИНИТЕЛЬНОМ ПАДЕЖЕ: «подарок НА одну монетУ».
 *
 * Склонение по числу и падеж - разные вещи, и продукт знал только первое:
 * в ленте эфира стояло «отправил подарок на 1 монета» (снимок владельца,
 * единица 17). Именительный и винительный расходятся только в
 * единственном числе, поэтому две формы из трёх повторяются - и это не
 * повод обойтись одной.
 */
export const coinsAccusative = (n: number): string => plural(n, ['монету', 'монеты', 'монет']);
export const likes = (n: number): string => plural(n, ['лайк', 'лайка', 'лайков']);
export const gifts = (n: number): string => plural(n, ['подарок', 'подарка', 'подарков']);
export const comments = (n: number): string =>
  plural(n, ['комментарий', 'комментария', 'комментариев']);
export const viewers = (n: number): string => plural(n, ['зритель', 'зрителя', 'зрителей']);
export const games = (n: number): string => plural(n, ['игра', 'игры', 'игр']);
export const runs = (n: number): string => plural(n, ['эфир', 'эфира', 'эфиров']);
export const minutes = (n: number): string => plural(n, ['минута', 'минуты', 'минут']);
export const accounts = (n: number): string => plural(n, ['аккаунт', 'аккаунта', 'аккаунтов']);
export const sounds = (n: number): string => plural(n, ['звук', 'звука', 'звуков']);
